const WeatherCard = ({ day, place, icon, maxTemp, minTemp }) => {
	return (
		<div className='weather-card'>
			{day ? <p>{day.substring(0, 3)}</p> : <p>{place}</p>}
			{icon ? <img src={`../icons/${icon}.svg`} alt={`${icon} weather icon`} /> : null}
			<div className='weather-card__temperatures'>
				<p>{maxTemp}°</p>
				{minTemp ? <p>{minTemp}°</p> : null}
			</div>
		</div>
	);
};

export default WeatherCard;
